import { all, put, call, takeLatest, select } from 'redux-saga/effects';
import ApiService from '@/services/Api';
import actions, { actionTypes } from './actions';
import modalsActions from '../modals/actions';

function* fetchEnrichments({ payload }) {
  try {
    const { data } = yield call(ApiService.fetchProspectBulkEnrichments, payload);
    yield put(actions.fetchSuccess(data));
  } catch (error) {
    yield put(actions.fetchFailed(error));
  }
}

function* uploadFile({ payload }) {
  const { tableOptions } = yield select(({ bulkEnrichment }) => ({
    tableOptions: bulkEnrichment.tableOptions,
  }));
  try {
    const { data } = yield call(ApiService.uploadProspectBulkEnrichmentFile, payload);
    yield put(actions.uploadFileSuccess(data));
    yield put(actions.fetchEnrichments({ page: tableOptions.page, limit: tableOptions.limit }));
    yield put(modalsActions.toggleUploadBulkEnrichmentFileModal(false));
  } catch (error) {
    yield put(actions.uploadResourceFailed(error));
  }
}

function* deleteFile({ payload }) {
  const { tableOptions } = yield select(({ bulkEnrichment }) => ({
    tableOptions: bulkEnrichment.tableOptions,
  }));
  try {
    yield call(ApiService.deleteProspectBulkEnrichmentFile, payload);
    yield put(actions.deleteFileSuccess());
    yield put(actions.fetchEnrichments({ page: tableOptions.page, limit: tableOptions.limit }));
  } catch (error) {
    yield put(actions.deleteFileFailed(error));
  }
}

export default function* () {
  yield all([
    takeLatest(actionTypes.FETCH_ENRICHMENTS, fetchEnrichments),
    takeLatest(actionTypes.UPLOAD_FILE, uploadFile),
    takeLatest(actionTypes.DELETE_FILE, deleteFile),
  ]);
}
